module.exports = __webpack_public_path__ + "img/vertical_4_5_6005.7f3eb422.png";